import { Component, ChangeDetectionStrategy } from '@angular/core';
import { SubProject } from 'src/app/model/project/sub-project';
import { ProjectsTableComponent } from '../projects-table/projects-table.component';

@Component({
  selector: 'verify-location-projects',
  templateUrl: '../projects-table/projects-table.component.html',
  styleUrls: ['../projects-table/projects-table.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class VerifyLocationProjectsComponent extends ProjectsTableComponent {
  ngOnInit() {
    super.ngOnInit();
    this.projects = [];
    this.displayedColumns = [
      'project_id',
      'currentRequestDate',
      'currentConfirmedPlacementDate',
      'company',
      'projectPlacement.address',
      'productType',
      'productSize',
      'placer',
      'displayStatus',
      'star'
    ];
  }

  // Override
  protected preProcessProjects(projects: SubProject[]): void {
    if (projects == null) {
      return;
    }

    super.preProcessProjects(projects);
    projects.forEach(p => {
      p.applyGreenBackground =
        p.projectPlacement != null && p.projectPlacement.locationVerified;
    });
  }

  protected getLocalStorageKey(): string {
    return 'VerifyLocationProjectsComponent';
  }

  protected getStatusFilter(): string {
    return 'statusSubstatus/In_behandeling/Locatiebepaling';
  }

  public getPageTitle(): string {
    return 'Locatiebepaling';
  }

  // Override
  public getDefaultSort() {
    return 'currentConfirmedPlacementDate';
  }
}
